/* eslint-disable import/order */
import React from 'react';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { loginEmbedRoute } from '@jira/router-routes__login-embed-routes/src/loginEmbedRoute.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Route } from '@atlassian/react-resource-router';
import type LoginEmbedType from './login-embed-error-page/LoginEmbedErrorPage.tsx';

const LazyLoginEmbed = lazyForPaint<typeof LoginEmbedType>(
	() =>
		import(
			/* webpackChunkName: "async-login-embed", jiraSpaEntry: "async-login-embed" */ './login-embed-error-page/LoginEmbedErrorPage.tsx'
		),
);

const LoginEmbed = () => (
	<LazyPage Page={LazyLoginEmbed} pageId="spa-apps/login-embed" shouldShowSpinner />
);

export const loginEmbedRouteEntry: Route = createEntry(loginEmbedRoute, () => ({
	group: 'errors',
	// eslint-disable-next-line no-restricted-syntax
	component: LoginEmbed,
	layout: chromelessLayout,
	resources: [...jiraSpaResources()],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
